module.exports = __webpack_public_path__ + "img/news_02.8094bb9b.jpg";